import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqEmpresaFatura = {
	listInvoice: async function () {
		return apiServer
			.get(`portal/v1/empresa/faturas`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listInvoiceEnterpriseID: async function (id) {
		return apiServer
			.get(`portal/v1/empresa/${id}/faturas`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listIdInvoiceAndIdEnterprise: async function (id_fatura, id_empresa) {
		return apiServer
			.get(`portal/v1/empresa/fatura`, {
				headers: {
					banco,
				},
				params: {
					id_fatura,
					id_empresa,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listId: async function (id) {
		return apiServer
			.get(`portal/v1/empresa/fatura/${id}`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqEmpresaFatura;
